import { authGuard } from '@/features/auth/guards/authGuard.js'
import { sessionGuard } from '@/features/auth/guards/sessionGuard.js'
import {
  CLUB_SELF_REGISTRATION_DISABLED,
  CLUB_SELECTOR_PATH,
} from '@/features/auth/clubSelfRegistrationConfig.js'
import ClubRegisterView from '@/features/clubRegister/views/ClubRegisterView.vue'

const clubRegisterRedirectRoutes = [
  {
    path: 'club-register/:pathMatch(.*)*',
    redirect: CLUB_SELECTOR_PATH,
  },
]

const clubRegisterFullRoutes = [
  {
    path: 'club-register',
    component: ClubRegisterView,
    name: 'clubRegister',
    children: [
      {
        path: '',
        component: () => import('@/features/clubRegister/views/login/ClubRegisterLogin.vue'),
      },
      {
        path: 'details',
        component: () =>
          import('@/features/clubRegister/views/orgDetails/ClubRegisterOrgDetails.vue'),
        beforeEnter: [authGuard, sessionGuard],
      },
      {
        path: 'structure',
        component: () =>
          import('@/features/clubRegister/views/orgStructure/ClubRegisterOrgStructure.vue'),
        beforeEnter: [authGuard, sessionGuard],
      },
      {
        path: 'contact',
        component: () =>
          import('@/features/clubRegister/views/publicContact/ClubRegisterPublicContact.vue'),
        beforeEnter: [authGuard, sessionGuard],
      },
      {
        path: 'type',
        component: () => import('@/features/clubRegister/views/orgType/ClubRegisterOrgType.vue'),
        beforeEnter: [authGuard, sessionGuard],
      },
      {
        path: 'terminology',
        component: () =>
          import('@/features/clubRegister/views/terminology/ClubRegisterTerminology.vue'),
        beforeEnter: [authGuard, sessionGuard],
      },
      {
        path: 'branding',
        component: () =>
          import('@/features/clubRegister/views/orgBranding/ClubRegisterOrgBranding.vue'),
        beforeEnter: [authGuard, sessionGuard],
      },
      {
        path: 'background',
        component: () =>
          import('@/features/clubRegister/views/background/ClubRegisterBackground.vue'),
        beforeEnter: [authGuard, sessionGuard],
      },
      {
        path: 'components',
        component: () =>
          import('@/features/clubRegister/views/components/ClubRegisterComponents.vue'),
        beforeEnter: [authGuard, sessionGuard],
      },
      {
        path: 'summary',
        component: () => import('@/features/clubRegister/views/summary/ClubRegisterSummary.vue'),
        beforeEnter: [authGuard, sessionGuard],
      },
    ],
  },
]

export const clubRegisterRoutes = CLUB_SELF_REGISTRATION_DISABLED
  ? clubRegisterRedirectRoutes
  : clubRegisterFullRoutes
